import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { servicesData } from "./service_data";
import "./Service_com.css";
import FeatureCards from "../Banner/Banner";

function Service_com() {
  const navigate = useNavigate();
  const { id } = useParams();
  const service = servicesData.find(s => s.id === parseInt(id));

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    }, 100);
  }, [id]);

  if (!service) {
    return (
      <div className="service_detail_error">
        <h2>Service not found</h2>
        <button onClick={() => navigate("/")} className="back_btn">
          Back to Services
        </button>
      </div>
    );
  }

  return (
    <div className="service_detail_container">
      <button onClick={() => navigate("/")} className="back_btn">
  <span className="back_icon">←</span>
  Back to Home
</button>
      <div className="service_detail_content">
        {/* LEFT - IMAGE */}
        <div className="service_detail_image">
          <img src={service.img} alt={service.title} />
        </div>

        {/* RIGHT - DETAILS */}
        <div className="service_detail_info">
          {/* ICON AND TITLE */}
          <div className="service_header">
            <div className="service_icon_large">
              <img src={service.icon} alt={service.title} />
            </div>
            <h1>{service.title}</h1>
          </div>

          {/* PRICE */}
          <div className="service_price">
            <span className="price_label">Starting Price:</span>
            <span className="price_value">{service.price}</span>
          </div>

          {/* SHORT DESCRIPTION */}

          {/* FULL DESCRIPTION */}
          <div className="service_full_desc">
            <h3>About This Service</h3>
            <p>{service.fullDescription}</p>
          </div>

          {/* FEATURES LIST */}
          <div className="service_features">
            <h3>What's Included</h3>
            <ul>
              {service.features.map((feature, index) => (
                <li key={index}>
                  <span className="feature_check">✓</span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          {/* CTA BUTTONS */}
          <div className="HeroPart_buttons">
        {/* 📞 Call */}
        <button
          className="Hero_Callnow"
          onClick={() =>
    window.location.href="tel:+971521743345"
  }
        >
          Contact Us
        </button>

        {/* 💬 WhatsApp Get Quote */}
        <button
          className="Hero_SS"
          onClick={() =>
            window.open(
              "https://wa.me/971521743345?text=Hi%2C%20I%E2%80%99d%20like%20to%20request%20a%20quote%20for%20home%20maintenance%20services.",
              "_blank"
            )
          }
        >
          Get In Touch
        </button>
      </div>
        </div>
      </div>

      <FeatureCards />

      {/* RELATED SERVICES */}
      <div className="related_services">
        <h2>Other Services</h2>
        <div className="related_grid">
          {servicesData.filter(s => s.id !== service.id).slice(0, 3).map(relService => (
            <div 
              key={relService.id} 
              className="related_service_card"
              onClick={() => navigate(`/service/${relService.id}`)}
            >
              <img src={relService.img} alt={relService.title} />
              <h4>{relService.title}</h4>
              <p>{relService.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Service_com;
